import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import JavaIcon from '@mui/icons-material/Code'; // Placeholder for Java
import HtmlIcon from '@mui/icons-material/Language'; // Placeholder for HTML
import CssIcon from '@mui/icons-material/Palette'; // Placeholder for CSS
import ReactIcon from '@mui/icons-material/AutoAwesome'; // Placeholder for React
import GitHubIcon from '@mui/icons-material/GitHub';

// Outer Container Styling
const OuterContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#515669',
  borderRadius: '12px',
  boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)',
  maxWidth: '80%',
  margin: '0 auto',
}));

// Skill Box Styling
const SkillBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3), // Slightly larger box
  backgroundColor: '#fff',
  borderRadius: '10px',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.3s',
  '&:hover': {
    transform: 'scale(1.1)', // Slightly larger scale on hover
  },
}));

// Container Styling for Flex Layout
const SkillsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(4), // Increased gap for better spacing
}));

const Skills = () => {
  const skills = [
    { name: 'Java', icon: <JavaIcon fontSize="large" sx={{ color: '#f89820' }} /> },
    { name: 'HTML', icon: <HtmlIcon fontSize="large" sx={{ color: '#e34f26' }} /> },
    { name: 'CSS', icon: <CssIcon fontSize="large" sx={{ color: '#264de4' }} /> },
    { name: 'React', icon: <ReactIcon fontSize="large" sx={{ color: '#61dafb' }} /> },
    { name: 'GitHub', icon: <GitHubIcon fontSize="large" sx={{ color: '#333' }} /> },
  ];

  return (
    <Box sx={{ py: 6, px: 2 }}>
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          textAlign: 'center',
          mb: 4,
          fontWeight: 'bold',
          color: '#333',
        }}
      >
        Skills
      </Typography>

      {/* Outer Container */}
      <OuterContainer>
        {/* Skills Flexbox */}
        <SkillsContainer>
          {skills.map((skill, index) => (
            <SkillBox key={index}>
              {/* Skill Icon */}
              {skill.icon}
              {/* Skill Name */}
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontWeight: 'bold',
                  fontSize: '1.3rem', // Slightly larger font
                  color: '#555',
                }}
              >
                {skill.name}
              </Typography>
            </SkillBox>
          ))}
        </SkillsContainer>
      </OuterContainer>
    </Box>
  );
};

export default Skills;
